/** The controls the browser can reach with Tab, in its positive-index-first order. */
export function dialogTabStops(root: HTMLElement): HTMLElement[] {
  return [
    ...root.querySelectorAll<HTMLElement>(
      'button,input,select,textarea,summary,a[href],[tabindex]',
    ),
  ]
    .filter(
      (element) =>
        element.tabIndex >= 0 &&
        !element.matches(':disabled') &&
        !element.closest('[inert]') &&
        element.getClientRects().length > 0 &&
        getComputedStyle(element).visibility === 'visible',
    )
    .sort((a, b) => (a.tabIndex || Infinity) - (b.tabIndex || Infinity));
}

export function dialogTabWrapTarget(
  root: HTMLElement,
  active: Element | null,
  backwards: boolean,
): HTMLElement | null {
  const items = dialogTabStops(root),
    first = items[0],
    last = items.at(-1);
  if (!first) return root;
  if (backwards && (active === first || active === root || !root.contains(active))) return last!;
  if (!backwards && (active === last || !root.contains(active))) return first;
  return null;
}

export function isTopVisibleDialog(root: HTMLElement | null): boolean {
  return (
    root !== null &&
    [...document.querySelectorAll('[role="dialog"]')]
      .filter(
        (dialog) =>
          dialog.getClientRects().length > 0 &&
          !dialog.closest('[inert]') &&
          getComputedStyle(dialog).visibility === 'visible',
      )
      .at(-1) === root
  );
}

export function dialogRestoreTarget(
  root: HTMLElement | null,
  previous: HTMLElement | null,
  active: Element | null,
  body: HTMLElement,
): HTMLElement | null {
  // Closing an older dialog must not steal focus from a newer dialog or from
  // a deliberate navigation outside it. Removed launch controls stay removed.
  return previous?.isConnected &&
    !previous.closest('[inert]') &&
    (active === body || active === root || root?.contains(active))
    ? previous
    : null;
}
